// extracted by mini-css-extract-plugin
export var boxItems = "_br-1";
export var boxItemsLg = "_br-2";
export var button = "_br-7";
export var buttonLg = "_br-8";
export var filterGroupBox = "_br-0";
export var icon = "_br-3";
export var iconSecondary = "_br-6";
export var iconWrapper = "_br-4";
export var iconWrapperLg = "_br-5";